import * as React from "react";
import { Icon } from "../Icon/icon";
export interface ISearchButtonProps {
  searchStateCallback: any;
  searchText: string;
  searchIsOpen: boolean;
  searchPanelId: string;
}

export const SearchButton: React.SFC<ISearchButtonProps> = (props) => (
  <button
    onClick={props.searchStateCallback}
    className="siteheader__button"
    aria-expanded={props.searchIsOpen}
    aria-controls={props.searchPanelId}
  >
    <svg
      className="search-open"
      aria-hidden="true"
      width="28px"
      height="26px"
      viewBox="0 0 28 26"
    >
      <g
        transform="translate(2.000000, 1.000000)"
        fill="#000000"
        stroke="#000000"
      >
        <path d="M23.5598101,21.5565733 L16.9888918,14.9828248 C18.1667382,13.3762957 18.797706,11.4340404 18.7889085,9.44198366 C18.7664345,4.2420547 14.5607926,0.0301290775 9.36110651,9.55209229e-05 C6.87276362,-0.0111632398 4.4832692,0.973268436 2.72493502,2.73408701 C0.966600833,4.49490559 -0.0145114412,6.88584303 0.000162259029,9.37426608 C0.0226362579,14.5746684 4.22866195,18.7869778 9.42882142,18.8170114 C11.4289147,18.8256804 13.3781893,18.1873227 14.9857303,16.9972085 L14.9925875,16.9920654 L21.5575057,23.5606709 C21.9124499,23.933055 22.441341,24.0837873 22.9392584,23.9544661 C23.4371758,23.8251449 23.8258822,23.4360904 23.9547722,22.9380429 C24.0836621,22.4399954 23.9324831,21.9112127 23.5598101,21.5565733 L23.5598101,21.5565733 Z M9.42196421,16.9346341 C5.2620639,16.9107032 1.89729805,13.5412164 1.87903688,9.38112355 C1.86780922,7.39064294 2.65276362,5.47827713 4.05916612,4.06972631 C5.46556863,2.6611755 7.37668981,1.8733474 9.36710656,1.88161567 C13.5270069,1.90554653 16.8917727,5.27503334 16.9100339,9.43512618 C16.9212616,11.4256068 16.1363072,13.3379726 14.7299047,14.7465234 C13.3235021,16.1550742 11.412381,16.9429023 9.42196421,16.9346341 Z" />
      </g>
    </svg>
    <Icon iconType="fontawesome/close-menu" className="search-close" />
    <span className="display-block">{props.searchText}</span>
  </button>
);
